import { render, staticRenderFns } from "./DefaultTemplate.vue?vue&type=template&id=d99293b6&scoped=true&"
import script from "./DefaultTemplate.vue?vue&type=script&lang=js&"
export * from "./DefaultTemplate.vue?vue&type=script&lang=js&"
import style0 from "./DefaultTemplate.vue?vue&type=style&index=0&id=d99293b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d99293b6",
  null
  
)

export default component.exports